import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../../styles';
import ButtonSet from '../../ButtonSet';

const styles = css`
  margin: 30px 0;
  @media (min-width: 992px) {
    margin: 90px 0 0 0;
  }
  .PreferredLenderList {
    padding: 30px 0 30px 0;
    position: relative;
    @media (min-width: 992px) {
      padding: 120px 0 90px 0;
      background: linear-gradient(149.58deg, rgba(227,239,247,0) 0%, #E3EFF7 100%);
    }
  }
  .PreferredLenderList_iconGraphic {
    width: 90px;
    height: 90px;
    background-color: ${colors.white};
    border-radius: 50%;
    border: 8px solid ${colors.brand2};
    position: absolute;
    z-index: 3;
    left: 50%;
    top: -45px;
    transform: translateX(-50%);
    background-size: auto 56px;
    background-position: center center;
    background-repeat: no-repeat;
    display: none;
    @media (min-width: 992px) {
      width: 140px;
      height: 140px;
      top: -70px;
      background-size: auto 56px;
      display: flex;
    }
  }
  .PreferredLenderList_list {
    @media (min-width: 992px) {
      display: flex;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
    }
  }
  .PreferredLenderList_item {
    background: ${colors.white};
    width: 100%;
    background: #FFFFFF;
    padding: 20px;
    @media (min-width: 992px) {
      width: calc(47% - 30px);
      padding: 60px;
      margin: 17px;
      box-shadow: 0 9px 12px 0 rgba(0,0,0,0.10);
    }
    @media (min-width: 992px) {
      width: calc(33% - 30px);
    }
  }
  h3 {
    font-weight: 700;
    text-transform: uppercase;
    ::after {
      content: '';
      display: block;
      margin: 15px 0 15px 0;
      width: 75px;
      height: 2px;
      background-color: ${colors.brand3};
      @media (min-width: 992px) {
        margin: 20px 0 20px 0;
      }
      @media (min-width: 1400px) {
        margin: 25px 0 25px 0;
      }
    }
  }
  .buttonSet__containerColumn {
    @media (min-width: 768px) {
      width: 30%;
    }
    @media (min-width: 992px) {
      width: auto;
    }
  }
  .buttonSet {
    margin: 40px 0 0 0;
  }
  .btn {
    padding: 16px 25px;
    font-size: 14px;
  }
  .PreferredLenderList_info {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 15px 0;
  }
  .PreferredLender_communitiesList {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;

function PreferredLenderList({ content, widget, communities }) {
  return (
    <div className={styles}>
      <div className="PreferredLenderList">
        {
          get(content, '[0].icon.contentUrl') &&
          <div className="PreferredLenderList_iconGraphic" style={{ backgroundImage: `url(${get(content, '[0].icon.contentUrl')}` }} />
        }
        <div className="container PreferredLenderList_list">
          {
            get(widget, 'lender_list').map(lender => (
              <div className="PreferredLenderList_item" key={lender._id}>
                <h3>{get(lender, 'name')}</h3>
                <span className="PreferredLenderList_info">{get(lender, 'company')}, {get(lender, 'state')}</span>
                <ul className="PreferredLender_communitiesList">
                  {
                    orderBy(
                      communities
                      .filter(community => (community.preferred_lenders || [])
                      .includes(lender._id)),
                      'name',
                    )
                    .map(community => (
                      <li key={community._id}>
                        <Link name="community-detail" community={community}>{community.name}</Link>
                      </li>
                    ))
                  }
                </ul>
                <ButtonSet buttonSetParent={lender} />
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

PreferredLenderList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  widget: PropTypes.arrayOf(PropTypes.object).isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    widget: 'lenders',
    communities: 'all',
  },
)(PreferredLenderList);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PreferredLenderList.section.js